import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { StripeSubscriptionEventDto } from '@workspace/data-types';
import { CodeBlockComponent, LuxonDatePipe, SimpleChipComponent } from '@workspace/ng-aura';

@Component({
  selector: 'core-stripe-subscription-event-details',
  templateUrl: './stripe-subscription-event-details.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, MatDividerModule, LuxonDatePipe, SimpleChipComponent, CodeBlockComponent],
})
export class StripeSubscriptionEventDetailsCoreComponent {
  event = input.required<StripeSubscriptionEventDto>();
}
